<div class="mx-auto grid max-w-[900px] gap-6 p-4 text-slate-900">

  <div class="grid gap-4">
    <a routerLink="/energy-admin" class="text-[13px] text-slate-600">&larr; Admin</a>
    <h1 class="m-0 text-xl font-bold">Preise</h1>
  </div>

  <section class="grid gap-3">
    <h2 class="m-0 text-[15px] font-bold">CSV importieren</h2>

    <p class="m-0 text-[13px] leading-relaxed text-slate-600">
      POST <code>{{ importPath }}</code>. Kopfzeile
      <code>price_timestamp,origin,tariff,interval_minutes,price,unit</code>, Preise in
      <strong>EUR/MWH</strong>. Vorhandene Daten werden überschrieben!
    </p>

    <label
      class="block cursor-pointer border border-dashed border-slate-400 p-3 text-[13px]"
      [class.bg-slate-100]="isDragging()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave()"
      (drop)="onDrop($event)"
      >
      <input
        type="file"
        accept=".csv,text/csv"
        class="hidden"
        [disabled]="isRunning()"
        (change)="onFileSelected($event)"
        />
      CSV-Datei wählen oder hier ziehen.
    </label>

    @if (preview(); as file) {
      <div class="text-[13px] text-slate-600">
        <strong class="text-slate-900">{{ file.name }}</strong>, {{ file.sizeLabel }},
        {{ file.rowCount }} Datenzeilen@if (file.firstTimestamp) {
        <span>, von
          <code>{{ file.firstTimestamp }}</code> bis <code>{{ file.lastTimestamp }}</code></span>
        }
        <button type="button" class="ml-2 underline" (click)="clearFile()">Entfernen</button>
      </div>
    }

    <label class="flex items-start gap-2 text-[13px]">
      <input
        type="checkbox"
        class="mt-0.5"
        [ngModel]="replaceRange()"
        (ngModelChange)="replaceRange.set($event)"
        [disabled]="isRunning()"
        />
      <span>
        Daten erst löschen - löscht Timeseries im Zeitraum vom CSV.
      </span>
    </label>

    <div class="flex flex-wrap items-center gap-2 text-[13px]">
      <button
        type="button"
        class="border border-slate-400 px-3 py-1.5 disabled:opacity-50"
        [disabled]="!canImport()"
        (click)="runImport(false)">
        Importieren
      </button>

      <button
        type="button"
        class="border border-slate-400 px-3 py-1.5 disabled:opacity-50"
        [disabled]="!canImport()"
        (click)="runImport(true)">
        Vorschau
      </button>

      <span class="text-slate-600">Vorschau schreibt nichts (für Fehlersuche).</span>
    </div>
  </section>

  @if (phase() === 'running') {
    <section class="text-[13px] font-semibold" role="status" aria-live="polite">
      {{ runningLabel() }}
    </section>
  }

  @if (phase() === 'error' && errorMessage()) {
    <section class="grid gap-1 text-[13px] text-red-800" role="alert">
      <div class="font-semibold">
        Nicht ausgeführt
        <button type="button" class="ml-2 font-normal underline" (click)="dismiss()">Schließen</button>
      </div>
      <pre class="m-0 whitespace-pre-wrap break-words">{{ errorMessage() }}</pre>
    </section>
  }

  @if (phase() === 'success' && importResult(); as result) {
    <section class="grid gap-3 text-[13px]" role="status">
      <div class="font-semibold">
        {{ result.dryRun ? 'Vorschau berechnet + nichts geschrieben' : 'Import abgeschlossen' }}
        <button type="button" class="ml-2 font-normal underline" (click)="dismiss()">Schließen</button>
      </div>

      <div class="overflow-x-auto">
        <table class="min-w-[480px] border-collapse text-left">
          <thead>
            <tr class="text-slate-600">
              <th class="py-1 pr-6 font-semibold">Zeilen</th>
              <th class="py-1 pr-6 font-semibold">Neu</th>
              <th class="py-1 pr-6 font-semibold">Updated</th>
              <th class="py-1 pr-6 font-semibold">Kein Update</th>
              <th class="py-1 pr-6 font-semibold">Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr class="font-mono">
              <td class="py-1 pr-6">{{ result.rowsParsed }}</td>
              <td class="py-1 pr-6">{{ result.inserted }}</td>
              <td class="py-1 pr-6">{{ result.updated }}</td>
              <td class="py-1 pr-6">{{ result.unchanged }}</td>
              <td class="py-1 pr-6" [class.font-bold]="(result.deleted ?? 0) > 0">{{ result.deleted }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      @if (result.warnings?.length) {
        <div class="grid gap-1">
          <div class="font-semibold">Hinweise</div>
          <ul class="m-0 grid list-disc gap-1 pl-5">
            @for (warning of result.warnings; track warning) {
              <li>{{ warning }}</li>
            }
          </ul>
        </div>
      }
    </section>
  }

  @if (phase() === 'success' && refreshResult(); as result) {
    <section class="grid gap-1 text-[13px]" role="status">
      <div class="font-semibold">
        ENTSO-E abgefragt
      </div>
      <div>
        {{ result.daysPolled }} Liefertag(e) von {{ result.startDate }} bis {{ result.endDate }},
        <strong>{{ result.changedPoints }}</strong> Preise geändert.
      </div>
    </section>
  }
</div>
